import { FunctionComponent, useContext, useMemo } from 'react';

import { PORTAL_URL } from 'src/constants/externalUrls';
import { PortalConfigContext } from 'src/context';
import { useGetPortalPlanQuery } from 'src/services/api';
import { canDisablePortalBadge } from 'src/utils/PlansUtils';

import { AuthScreenPortalBadgeIcon } from './AuthScreenPortalBadgeIcon';

interface Props {
  isAuthScreen: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future. Please use the  `src/features/badge/PoweredByAssemblyBadge.tsx` component instead.
 */

export const AuthScreenPortalBadge: FunctionComponent<Props> = ({
  isAuthScreen,
}) => {
  const portalConfig = useContext(PortalConfigContext);
  const { data: portalPlanData, isSuccess } = useGetPortalPlanQuery({
    isAuthScreen,
  });

  /**
   * This method check for portal plan status. It call
   * get portal plan api which return if the portal is in pro
   * plan or not. And then, it updates the portal badge render condition
   * When it is a pro plan, get show badge flag prop from
   * the portal config, otherwise it should be explicitly shown.
   */
  const shouldShowPortalBadge = useMemo(() => {
    if (isSuccess) {
      const { isPro, isLegacyPaidPlan, isStudioPlan, planType } =
        portalPlanData;
      const canDisableBadge = canDisablePortalBadge({
        isPro,
        isLegacyPaidPlan,
        isStudioPlan,
        planType,
      });
      return canDisableBadge ? !portalConfig.MarketingSite.disableBadge : true;
    }
    return false;
  }, [portalPlanData, isSuccess]);

  if (!shouldShowPortalBadge) return null;

  return (
    <div className="group pr-4 z-10 relative rounded mt-6">
      <a
        href={`${PORTAL_URL}/?utm_medium=powered_by&utm_source=${encodeURIComponent(
          window.location.href,
        )}`}
        target="_blank"
        className="flex items-center gap-2 justify-center no-underline"
        rel="noreferrer"
      >
        <AuthScreenPortalBadgeIcon />
      </a>
    </div>
  );
};
